import { getSnapShotIndexes, getSnapShotIndexesInfo } from "@/stores/dataStore/reduxStore/indexSlice"
import { RootState, store } from "@/stores/dataStore/reduxStore/store"
const dispatch = store.dispatch

export const StoreMarketIndexes = (state: RootState) => state.indexes.marketIndexes
export const StoreMarketIndexesInfo = (state: RootState) => state.indexes.marketIndexInfo

export const getSnapShotIndexesInfoAction = () => {
    return dispatch(getSnapShotIndexesInfo())
}

export const getSnapShotIndexesAction = () => {
    return dispatch(getSnapShotIndexes())
}